import React from 'react'
import { Header } from '../Header/Header'

export const Asap = () => {
    return (
        <div>
            <div id='computer-courses'>
                <Header />
                <section className='ttm-row introduction-section break-1199-colum clearfix'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 content-area'>
                                <div className='ttm-service-single-content-area'>
                                    <div className='row'>
                                        <div className='col-sm-12'>
                                            <div className='ttm-service-description'>
                                                <div className='section-title with-desc text-center clearfix'>
                                                    <div className='container'>
                                                        <h2 className='title'>ASAP (ADDITIONAL SKILL ACQUISTION PROGRAMME -SKILL)
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className='container'>
                                                    <div className='sep_holder_box width-100 mb-20'>
                                                        <span className='sep_holder'>
                                                            <span className='sep_line'></span>
                                                        </span>
                                                        <span className='sep_holder'>
                                                            <span className='sep_line'></span>
                                                        </span>
                                                    </div>

                                                    <div className='row mt-15 mb-15'>
                                                        <div className='col-sm-6'>
                                                            <ul className='ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey'>
                                                                <li>
                                                                    <i className='fa fa-arrow-circle-right'></i>
                                                                    <span className='ttm-list-li-content'>
                                                                       GENERAL DUTY ASSISTANT -ADVANCED- 1 YEAR (NCVET CERTIFICATE PROVIDED)


                                                                    </span>
                                                                </li>
                                                               



                                                            </ul>
                                                        </div>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    )
}
